import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import type { User } from 'firebase/auth';
import { db } from './firebase';

/**
 * Creates /users/{uid} on first sign-in if it doesn't already exist.
 * Idempotent. Client-side fallback for Sprint 3 — when we move to a
 * Cloud Function auth trigger in a later sprint, this can be removed
 * (or kept as a belt-and-suspenders safety net).
 *
 * Per firestore.rules, clients can only set non-server fields. We
 * deliberately omit `subscription` and `stripeCustomerId` — the
 * webhook writes those via admin SDK.
 */
export async function ensureUserDoc(authUser: User): Promise<void> {
  const ref = doc(db, 'users', authUser.uid);
  const snap = await getDoc(ref);
  if (snap.exists()) return;
  await setDoc(ref, {
    uid: authUser.uid,
    email: authUser.email ?? '',
    displayName: authUser.displayName ?? '',
    photoURL: authUser.photoURL ?? null,
    createdAt: serverTimestamp(),
  });
}
